import {useCallback, useEffect, useLayoutEffect, useMemo, useRef} from 'react'

/**
 * Hook for the mounted status of a component.
 * @param {boolean} layout          whether the layout effects should be listened to instead of effects.
 * @param {boolean} log             whether should log
 * @return {function(): boolean}
 */
const useIsMounted = (layout = false) => {
    const effectIsMounted = useRef(false)
    const layoutEffectIsMounted = useRef(false)

    /**
     * As soon as the component mounts, sets the isMounted to true
     * As soon as the component un-mounts, sets the isMounted to false
     */
    useLayoutEffect(() => {
        layoutEffectIsMounted.current = true
        return () => {
            layoutEffectIsMounted.current = false
        }
    }, [])

    /**
     * As soon as the component mounts, sets the isMounted to true
     * As soon as the component un-mounts, sets the isMounted to false
     */
    useEffect(() => {
        effectIsMounted.current = true
        return () => {
            effectIsMounted.current = false
        }
    }, [])


    const isMounted = useCallback(() => effectIsMounted.current, []);
    const isLayoutMounted = useCallback(() => layoutEffectIsMounted.current, []);

    return useMemo(() => {
        if (layout) {
            return isLayoutMounted;
        }
        return isMounted;
    }, [isLayoutMounted, isMounted, layout])
}

export default useIsMounted;
